import React, { useEffect, useState } from "react";
import { Topbar } from "@components";
import {
  RootContainer,
  RefreshIcon,
  ImageWrapper,
  ActionsWrapper,
  ActionButton,
  ActionLabel,
  ListContainer,
  EmptyText,
  ListItem,
  Wrapper,
  ItemText,
  DateText,
  AmountText,
  StatusText,
  ExpiredText,
  ExpiredLabel,
  BonusStatusText,
  DataWrapper,
  BalanceContainer,
  WalletImage,
  TotalBalanceContainer,
  TotalBalanceTitle,
  TotalBalanceText,
  SubContainer,
  SubTitle,
  SubBalance,
  Image,
  TitleWrapper,
  Title,
  LinkText,
  LogoImage,
} from "./Wallet.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import { TOPUP_LK, WITHDRAW_SK, BONUS_SK } from "@constants";
import { useDispatch, useSelector } from "react-redux";
import { getFormattedNumber, localStorage } from "@utils";
import { api } from "@api";
import { saveUser } from "@redux/auth/authSlice";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import {
  TopUpOutlined,
  WithdrawOutlined,
  DOTFilled,
  BalanceLoading,
} from "@assets";
import { ContainerOutlined } from "@ant-design/icons";
import moment from "moment";
import { getStatus } from "@utils";
import Lottie from "react-lottie";

const dateFormat = "MMM DD, YYYY hh:mm:ss A";

export const BonusImage = () => (
  <ImageWrapper>
    <LogoImage />
  </ImageWrapper>
);

const Wallet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { main_balance, bonus, is_in_game } = useSelector(
    (state) => state.auth.user
  );
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getRecentHistory();

    // eslint-disable-next-line
  }, []);

  const getRecentHistory = () => {
    setLoading(true);
    api
      .getRecentHistory()
      .then(({ transactions, user }) => {
        setLoading(false);
        setData(transactions);

        // Save user to redux
        dispatch(saveUser(user));
        // Set user to localstorage
        localStorage.setUser(user);
      })
      .catch((error) => { });
  };

  const goToHome = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const goToTransactions = () => {
    navigate(`/${PRIVATE_ROUTE.TRANSACTIONS}`);
  };

  const handleTopUpClicked = () => {
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const handleWithdrawClicked = () => {
    navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const refresh = () => {
    window.location.reload();
  };

  const renderTop = () => (
    <>
      <BalanceContainer>
        <WalletImage />
        <TotalBalanceContainer>
          <TotalBalanceTitle>
            {t("wallet.walletTotalBalance")}
          </TotalBalanceTitle>
          <TotalBalanceText>
            {is_in_game ? (
              <Lottie
                options={{
                  animationData: BalanceLoading,
                }}
                height={23}
              />
            ) : (
              `${getFormattedNumber(main_balance + bonus)} Ks`
            )}
          </TotalBalanceText>
          <SubContainer>
            <DOTFilled />
            <SubTitle>{t("wallet.actualTopupLabel")}</SubTitle>
            <SubBalance>
              {`${is_in_game
                ? '-'
                : getFormattedNumber(main_balance)
                } Ks`}
            </SubBalance>
          </SubContainer>
          <SubContainer>
            <DOTFilled />
            <SubTitle>{t("wallet.bonusLabel")}</SubTitle>
            <SubBalance>
              {`${is_in_game
                ? '-'
                : getFormattedNumber(bonus)
                } Ks`}
            </SubBalance>
          </SubContainer>
        </TotalBalanceContainer>
      </BalanceContainer>
      <ActionsWrapper>
        <ActionButton onClick={handleTopUpClicked}>
          <ActionLabel>{t("wallet.walletTopUp")}</ActionLabel>
          <TopUpOutlined />
        </ActionButton>

        <ActionButton onClick={handleWithdrawClicked}>
          <ActionLabel>{t("wallet.walletWithdraw")}</ActionLabel>
          <WithdrawOutlined />
        </ActionButton>
      </ActionsWrapper>
    </>
  );

  const Loader = () => (
    <div className="loader">
      <Spin />
    </div>
  );

  const EmptyCard = () => (
    <div className="empty-box">
      <ContainerOutlined />
      <EmptyText>{t("common.noRecord")}</EmptyText>
    </div>
  );

  const List = () => (
    <>
      <TitleWrapper>
        <Title>{t("wallet.walletRecentHistory")}</Title>
        <LinkText onClick={goToTransactions}>
          {t("wallet.walletSeeAll")}
        </LinkText>
      </TitleWrapper>
      <ListContainer>
        {data.map((item, key) => (
          <ListItem key={key}>
            {item.type === BONUS_SK ? (
              <BonusImage />
            ) : (
              <Image
                src={item.payment_category_image}
                radius={
                  item.payment_category_name === "KBZ" ? "none" : "circle"
                }
              />
            )}
            <DataWrapper>
              <Wrapper>
                <ItemText>
                  {item.type === BONUS_SK
                    ? t("wallet.transactionHistoryBonusType", {
                      bonus_type: item.bonus_type.replaceAll('-bonus', ''),
                    })
                    : `${item.type === WITHDRAW_SK
                      ? t("wallet.walletWithdraw")
                      : t("wallet.walletTopUp")
                    } ${t("common.to")} ${item.num}`}
                </ItemText>
                <AmountText>
                  {`${getFormattedNumber(item.amount)} Ks.`}
                </AmountText>
              </Wrapper>
              <Wrapper>
                <DateText>
                  {moment.unix(item.created_at).format(dateFormat)}
                </DateText>
                {item.type === BONUS_SK && item.bonus_expired && (
                  <BonusStatusText status={item.status}>
                    {item.status === "Used"
                      ? t("wallet.bonusUsedText")
                      : t("wallet.bonusNotUsedText")}
                  </BonusStatusText>
                )}
                {item.type !== BONUS_SK && (
                  <StatusText status={item.status}>
                    {getStatus(item.status)}
                  </StatusText>
                )}
              </Wrapper>
              <Wrapper>
                {item.trx_num && <DateText>{`PIN: ${item.trx_num}`}</DateText>}
                {item.type === BONUS_SK && item.bonus_expired && (
                  <div style={{ display: "flex" }}>
                    <ExpiredLabel>{t("wallet.expiredLabel")}</ExpiredLabel>
                    <ExpiredText>
                      &nbsp;&nbsp;
                      {moment.unix(item.bonus_expired).format(dateFormat)}
                    </ExpiredText>
                  </div>
                )}
              </Wrapper>
            </DataWrapper>
          </ListItem>
        ))}
        {loading && <Loader />}
        {!loading && data.length === 0 && <EmptyCard />}
      </ListContainer>
    </>
  );

  return (
    <RootContainer>
      <Topbar
        title={t("wallet.walletTitle")}
        shadow={false}
        rightIcon={<RefreshIcon onClick={refresh} />}
        goBack={goToHome}
      />
      {renderTop()}
      <List />
    </RootContainer>
  );
};

export default Wallet;
